import { render } from "./Sellers.vue?vue&type=template&id=6847f2a4&scoped=true"
import script from "./Sellers.vue?vue&type=script&lang=js"
export * from "./Sellers.vue?vue&type=script&lang=js"

import "./Sellers.vue?vue&type=style&index=0&id=6847f2a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6847f2a4"

export default script